import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=020998eb"
import script from "./PageContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageContent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports